import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom"; // Import withRouter
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";
const token = localStorage.getItem('authToken');
class EditVolunteers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            name: "",
            category: "",
            areaInput: "",
            categoryData: [],
            city: "",
            imageFile: null,  // for storing the selected file
            imageUrl: null, 
            contactNo: '',
            pincode:"",
            designation:"",
            iscontactNoValid: true,
            ispincodeValid: true,
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
            errors: [],
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }

    async componentDidMount() {
        const { match } = this.props;
        if (match && match.params && match.params.id) {
            const { id } = match.params;
            this.setState({ id });
            await this.userData(id);
        } else {
            console.error("No match params found.");
        }
        
    }

    userData = async (id) => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/volunteers/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`, 
                }
            });
            console.log(response.data);
            if (response) {
                this.setState({
                    name: response.data.name,
                    contactNo: response.data.contactNo,
                    areaInput: response.data.city,
                    pincode: response.data.pincode,
                    designation: response.data.designation,
                    imageUrl:`https://uma-classees.blr1.digitaloceanspaces.com/${response.data.image}`,     // Assuming `imageUrl` field is in the response
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    
    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({
                imageFile: file,
                imageUrl: URL.createObjectURL(file), // Create a URL for preview
            });
        }
    };
    

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submeet: true });
    
        const { areaInput, name, contactNo, pincode, designation, imageFile } = this.state;
        const { id } = this.props.match.params;
    
        const formData = new FormData();
        formData.append('name', name);
        formData.append('city', areaInput);
        formData.append('contactNo', contactNo);
        formData.append('pincode', pincode);
        formData.append('designation', designation);
        if (imageFile) {
            formData.append('image', imageFile);
        }
    
        try {
            const response = await axios.put(`https://samaj.aasmo.in/api/admin/volunteers/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`, 
                },
            });
            if (response.status === 200) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                    this.props.history.push =( "/volunteersorcommittee");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };
    

    render() {
        const { name, contactNo, areaInput, designation, imageUrl, submeet, submissionStatus } = this.state;
        const isNameValid = name.trim().length > 0;
        const isContactNoValid = contactNo.trim().length > 0;
        const isAreaValid = areaInput.trim().length > 0;
        const isDesignationValid = designation.trim().length > 0;
    
        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Edit Volunteers or Committee</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                                    value={name}
                                    name="name"
                                    required=""
                                    type="text"
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                />
                                {!isNameValid && submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Contact No</label>
                                <input
                                    className={`form-control ${!isContactNoValid && submeet && "parsley-error"}`}
                                    value={contactNo}
                                    name="contactNo"
                                    required=""
                                    type="number"
                                    onChange={(e) => this.setState({ contactNo: e.target.value })}
                                />
                                {!isContactNoValid && submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>
                            <div className="form-group">
                                <label>City</label>
                                <textarea
                                    className={`form-control ${!isAreaValid && submeet && "parsley-error"}`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => this.setState({ areaInput: e.target.value })}
                                ></textarea>
                                {!isAreaValid && submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Designation</label>
                                <input
                                    className={`form-control ${!isDesignationValid && submeet && "parsley-error"}`}
                                    value={designation}
                                    name="designation"
                                    required=""
                                    type="text"
                                    onChange={(e) => this.setState({ designation: e.target.value })}
                                />
                                {!isDesignationValid && submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={this.handleImageChange}
                                />
                                {imageUrl && (
                                    <img src={imageUrl} alt="Preview" style={{ width: '200px', height: '150px', marginTop: '10px' }} />
                                )}
                            </div>
                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}
                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditVolunteers)); // Wrap with withRouter
